import { createLucideIcon } from 'lucide-react';

/**
 * Ícone custom "pessoa + seta pra direita" (encaminhar/transferir pra alguém) —
 * o lucide não tem esse exato. Desenhado no padrão lucide (viewBox 24, traço
 * currentColor). Base: user-round com uma seta pra direita no canto inferior
 * direito (variação C3). Compatível com o prop `icon` via createLucideIcon.
 */
export const TransferPerson = createLucideIcon('TransferPerson', [
  ['circle', { cx: '10', cy: '8', r: '5', key: 'head' }],
  ['path', { d: 'M2 21a8 8 0 0 1 13.292-6', key: 'body' }],
  ['path', { d: 'M16 19h6', key: 'arrow-line' }],
  ['path', { d: 'm19 16 3 3-3 3', key: 'arrow-head' }],
]);
